import { useMemo } from "react";

import { ThumbUp } from "components/icons/generated";
import { isSaasDistribution } from "utils/distribution";
import { MainNavigationItem } from "components/MainNavigation/types";

import {
  MAIN_NAVIGATION_SECONDARY_MENU_ITEMS,
  MainNavigationSecondaryMenuItemKeys,
} from "./menuItemsSecondary";

export const FEATUREBASE_URL = "https://feedback.spacelift.io/";
export const SUPPORT_GROUP_ID = "support";

const isSaas = isSaasDistribution();

const useFeedbackItemSaaS = (): MainNavigationItem | undefined => {
  const item = useMemo(
    () => ({
      id: SUPPORT_GROUP_ID,
      title: "Support & Feedback",
      icon: ThumbUp,
      items: [
        {
          items: [
            MAIN_NAVIGATION_SECONDARY_MENU_ITEMS[
              MainNavigationSecondaryMenuItemKeys.ProductUpdates
            ],
            MAIN_NAVIGATION_SECONDARY_MENU_ITEMS[MainNavigationSecondaryMenuItemKeys.SupportChat],
            MAIN_NAVIGATION_SECONDARY_MENU_ITEMS[
              MainNavigationSecondaryMenuItemKeys.KeyboardShortcuts
            ],
            MAIN_NAVIGATION_SECONDARY_MENU_ITEMS[MainNavigationSecondaryMenuItemKeys.Documentation],
          ],
        },
        {
          title: "Feedback",
          items: [
            MAIN_NAVIGATION_SECONDARY_MENU_ITEMS[
              MainNavigationSecondaryMenuItemKeys.RequestFeature
            ],
            MAIN_NAVIGATION_SECONDARY_MENU_ITEMS[
              MainNavigationSecondaryMenuItemKeys.FeedbackDashboard
            ],
          ],
        },
      ],
    }),
    []
  );

  if (!isSaas) {
    return undefined;
  }

  return item;
};

export default useFeedbackItemSaaS;
